{
  "editContactPrefsButton": "Kontaktpreferanser",
  "generalInformation": {
    "supplierNumber": "Leverandørnummer"
  },
  "communicationMethods": {
    "paper": "Brev",
    "email": "E-post",
    "sms": "SMS",
    "ehf": "EHF"
  },
  "contactPreferences": {
    "ehfUnavailableTitle": "EHF er ikke tilgjengelig",
    "ehfUnavailableDescription": "Skogeieren har ikke et organisasjonsnummer",
    "sectionGeneralTitle": "Generelt",
    "sectionInvoiceTitle": "Faktura",
    "sectionDocumentsTitle": "Dokumenter og avregninger",
    "exceptionBadgeLabel": "Unntak",
    "sentTo": "Sendes til",
    "selectSupplierNumber": "Velg leverandørnummer",
    "measurementDocumentLabel": "Måledokument",
    "measurementDocumentDescription": "Velg hvor skogeier ønsker å motta måledokument knyttet til dette leverandørnummeret.",
    "measurementRecipientLabel": "Hvem skal motta måledokumentene?",
    "measurementRecipientDescription": "Skriv fullt navn på personen som skal motta e-post, eller stå som mottaker på post.",
    "useCustomAddressLabel": "Mottaker er ikke innehaver av adressen",
    "useCustomAddressDescription": "Velg dette hvis posten skal sendes via en annen person eller en organisasjon (C/O).",
    "careOfLabel": "Navn på innehaver av adressen (C/O)",
    "noExceptionsRegistered": "Ingen unntak registrert",
    "addException": "Legg til unntak",
    "deleteExceptionTitle": "Slett unntak?",
    "deleteExceptionDescription": "Unntak for leverandørnummer slettes, og måledokument settes tilbake til standardvalg",
    "deleteExceptionButton": "Slett unntak",
    "backNavText": "Tilbake til kontaktpreferanser",
    "measurementDocumentsTitle": "Måledokumenter",
    "editCustomRecipient": "Endre egendefinert mottaker",
    "addCustomRecipient": "Legg til egendefinert mottaker",
    "customRecipientDescription": "Legg til egen mottaker for måledokumenter per leverandørnummer",
    "cancelAddTitle": "Vil du avbryte registrering av unntak?"
  }
}
